import {Toaster as RHTToaster} from 'react-hot-toast'

const Toaster = () => {
    return (
        <RHTToaster
            toastOptions={{
                style: {
                    padding: '16px',
                    boxShadow: 'var(--shadow-md)',
                    backgroundColor: 'var(--color-white)'
                },
                success: {
                    style: {
                        backgroundColor: 'var(--color-success-100)'
                    }
                },
                error: {
                    style: {
                        backgroundColor: 'var(--color-danger-100)'
                    }
                }
            }}
        />
    )
}

export default Toaster
